import { GoogleAnalytics } from "@onlinetools/adsense";
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { publicConfig } from "./config";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { NotFound } from "./NotFound";
import { PrivacyPolicy } from "./legal/PrivacyPolicy";
import { Terms } from "./legal/Terms";

const QrApp = lazy(() => import("./qr/App").then((m) => ({ default: m.App })));
const PdfMergerApp = lazy(() => import("./pdf-merger/App").then((m) => ({ default: m.App })));
const PdfConverterApp = lazy(() => import("./pdf-converter/App").then((m) => ({ default: m.App })));
const FormatApp = lazy(() => import("./format/App").then((m) => ({ default: m.App })));
const HomeApp = lazy(() => import("./home/Home").then((m) => ({ default: m.Home })));
const AboutApp = lazy(() => import("./about/About").then((m) => ({ default: m.About })));
const ContactApp = lazy(() => import("./about/Contact").then((m) => ({ default: m.Contact })));
const ImageCompressorApp = lazy(() => import("./image-compressor/App").then((m) => ({ default: m.App })));
const Base64App = lazy(() => import("./base64/App").then((m) => ({ default: m.App })));
const HashApp = lazy(() => import("./hash/App").then((m) => ({ default: m.App })));
const WordCounterApp = lazy(() => import("./word-counter/App").then((m) => ({ default: m.App })));

function PageLoader() {
  return (
    <output aria-label="Loading" className="page-loader">
      <div className="page-loader-spinner" />
    </output>
  );
}

export function App() {
  return (
    <>
      <GoogleAnalytics measurementId={publicConfig.googleAnalyticsId} />
      <Suspense fallback={<PageLoader />}>
        <ErrorBoundary>
          <Routes>
            <Route element={<HomeApp />} path="/" />
            <Route element={<QrApp />} path="/qr/*" />
            <Route element={<PdfMergerApp />} path="/pdf/merge/*" />
            <Route element={<PdfConverterApp />} path="/pdf/convert/*" />
            <Route element={<FormatApp />} path="/format/*" />
            <Route element={<PrivacyPolicy />} path="/privacy" />
            <Route element={<Terms />} path="/terms" />
            <Route element={<AboutApp />} path="/about" />
            <Route element={<ContactApp />} path="/contact" />
            <Route element={<ImageCompressorApp />} path="/image/compress/*" />
            <Route element={<Base64App />} path="/base64/*" />
            <Route element={<HashApp />} path="/hash/*" />
            <Route element={<WordCounterApp />} path="/word-count/*" />
            <Route element={<Navigate replace to="/pdf/merge" />} path="/pdf" />
            <Route element={<Navigate replace to="/pdf/merge" />} path="/pdf/" />
            <Route element={<Navigate replace to="/image/compress" />} path="/image" />
            <Route element={<Navigate replace to="/image/compress" />} path="/image/" />
            <Route element={<NotFound />} path="*" />
          </Routes>
        </ErrorBoundary>
      </Suspense>
    </>
  );
}
